import {
  // -- GET (list)
  GET_SCENARIO_PRODUCTS_SUCCESS,
  GET_SCENARIO_PRODUCTS_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_PRODUCT_SUCCESS,
  CREATE_SCENARIO_PRODUCT_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_PRODUCT_SUCCESS,
  UPDATE_SCENARIO_PRODUCT_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_PRODUCT_SUCCESS,
  DELETE_SCENARIO_PRODUCT_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIO_PRODUCTS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const scenarioProducts = (state = {}, action) => {
  switch (action.type) {
    // -- GET SCENARIO PRODUCTS (list)
    case GET_SCENARIO_PRODUCTS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioProducts.GET_SCENARIO_PRODUCTS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_PRODUCTS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioProducts.GET_SCENARIO_PRODUCTS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE SCENARIO PRODUCT
    case CREATE_SCENARIO_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioProducts.CREATE_SCENARIO_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_PRODUCT_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioProducts.CREATE_SCENARIO_PRODUCT_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO PRODUCT
    case UPDATE_SCENARIO_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioProducts.UPDATE_SCENARIO_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_PRODUCT_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioProducts.UPDATE_SCENARIO_PRODUCT_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE SCENARIO PRODUCT
    case DELETE_SCENARIO_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioProducts.DELETE_SCENARIO_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_PRODUCT_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioProducts.DELETE_SCENARIO_PRODUCT_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH SCENARIO
    case SEARCH_SCENARIO_PRODUCTS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
